import Card from 'creditcards/card';
import CardTypes from 'creditcards-types';

const card = Card(CardTypes);
export const FormatCardNumber = (number) => card.format(number);

export const FormatDate = (date) => {
    var formattedDate = new Date(date);
    const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    };
    return formattedDate.toLocaleDateString("en-AU", options);
};

export const CopyCardNumber = (cardNo) => {
    navigator.permissions.query({name: "clipboard-write"}).then(result => {
    if (result.state == "granted" || result.state == "prompt") {
        navigator.clipboard.writeText(cardNo).then(function() {
        alert('Card number copied to the clipboard.');
    }, function() {
        alert('Unable to copy the card number to the clipboard.');
        });
    }
});
};